import { useState } from "react";
import { useTranslation } from 'react-i18next';
import './Introduction.css';
import Video from "../Video/Video";
import { R2_MEDIA_BASE_URL } from '../../config/mediaConfig';

function Introduction({setIntroduced}) {
    const { t } = useTranslation();

    const finishIntro = () => {
        setIntroduced(true);
    }
    const [videoEnded, setVideoEnded] = useState(false);

    return (
        <div className="Introduction">
            <div className="intro-card">
                <div className="intro-header">
                    <h2>{t('introduction.welcomeTitle')}</h2>
                    <p>{t('introduction.subtitle')}</p>
                </div>

                <div className="intro-media">
                    <Video videoPath={`${R2_MEDIA_BASE_URL}/introduction/intro_orientation.mp4`} onEndedChange={setVideoEnded} />
                </div>
                <div className="intro-footer">
                    <button className="btn btn-large" onClick={finishIntro} disabled={!videoEnded}>{t('introduction.readyButton')}</button>
                </div>
            </div>
        </div>
    );
}

export default Introduction;